"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSalesmanList = void 0;
const Base_1 = require("./Base");
exports.GetSalesmanList = {
    url: Base_1.URL_BASE + "/GetSalesmanList",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetSalesmanList.js.map